<template>
<div id="modals">
    <link rel="stylesheet" href="/static/css/index3-style.css">
    <div class="window" v-if="modal">
        <div class="date-div">
            <input type="date" class="date-inp" placeholder=" Дата" v-model="date">
            <input type="time" class="time-inp" placeholder=" Время" v-model="time">
        </div>
        <div class="select-div">
            <div class="dropdown my-drop">
                <button class="btn-light btn dropdown-toggle" type="button" id="dropdownMenuButton"
                        data-toggle="dropdown"
                        aria-haspopup="true" aria-expanded="false" style="white-space: unset;position: relative;">{{text}}
                    <img class="my-dropdown" src="/static/img/dr-icon.png" alt="">
                </button>
                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                    <a class="dropdown-item"  v-for="situation in situations" :key="situation.id" @click="text = situation.name">{{situation.name}}</a>
                </div>
            </div>
        </div>
        <div class="inputs">
            <div class="input-div">
                <input type="text" class="new-input" placeholder=" Ваше Имя" v-model="name">
                <input type="text" class="new-input" placeholder=" Город" v-model="city">
                <input type="text" class="new-input" placeholder=" +7(___)___ - __ - __" data-inputmask="'mask': '+7(999)999-99-99'"  v-model="phone">
                <input type="text" class="new-input" placeholder=" E - mail" data-inputmask="'alias': 'email'" v-model="email">
            </div>
            <div class="img-div">
                <img src="/static/img/code.png" alt="">
            </div>
        </div>
            <input type="submit" class="send-btn t" value="Получить документы для суда " @click="sendDocs">
        <br>
        <br>
        <div class="text-div">
            <b class="index-3-text-1">Оплатите 249 рублей онлайн с любого банка по QR коду. Сканируйте его в
                Сбербанк Онлайн или другом банке.
                или перейдите на сайт платежной системы банка. Все платежи защищены.</b>
            <p class="index-3-text-2">
                1. После оплаты бухгалтерия самостоятельно произведет зачисление платежа. Квитанция
                не требуется.
                <br>
                2. Вам на почту придет подтверждение регистрации, а за час до начала разбора Вашего
                дела доступы в онлайн-кабинет.
                Возникли вопросы? Звоните по бесплатному номеру 8800000001
            </p>
        </div>
    </div>
    <div class="container th-container text-center" v-if="send">
        <div class="th-text">
            СПАСИБО!
            <br>
            Ваша заявка принята, проверьте
            <br>
            свою электронную почту.
        </div>
            <button class="send-btn-2" @click="send = 0">ОК</button>
    </div>
</div>
</template>

<script>
import axios from '@/router/http'
import Inputmask from 'inputmask'
export default {
    name: 'modals',
    props: ['user'],
    data () {
        return {
            modal: 1,
            send: 0,
            text: 'Выберите статью',
            situations: [],
            date: null,
            time: null,
            name: null,
            city: null,
            phone: null,
            email: null
        }
    },
    created () {
        Inputmask().mask(document.querySelectorAll('input'))

        const today = new Date()
        let y = today.getFullYear()
        let m = (today.getMonth() + 1)
        let d = today.getDate()
        let h = today.getHours()
        let i = today.getMinutes()
        if (y < 10) y = '0' + y
        if (m < 10) m = '0' + m
        if (d < 10) d = '0' + d
        if (h < 10) h = '0' + h
        if (i < 10) i = '0' + i
        this.date = y + '-' + m + '-' + d
        this.time = h + ':' + i
    },
    mounted () {
        axios.get('https://urist1.v-avtoservice.com/list/get-lists?id=6').then(response => {
            this.situations = response.data
        })
        Inputmask().mask(document.querySelectorAll('input'))
    },
    methods: {
        sendDocs () {
            if (!this.text || this.text === 'Выберите статью') alert('Вам необходимо выбрать статью')
            else if (!this.date) alert('Вам необходимо указать дату жалообы')
            else if (!this.time) alert('Вам необходимо указать время жалообы')
            else if (!this.name) alert('Вам необходимо указать как вас зовут')
            else if (!this.city) alert('Вам необходимо указать город')
            else if (!this.phone) alert('Вам необходимо указать телефон')
            else if (!this.email) alert('Вам необходимо указать email')
            else {
                this.$root.outsideModal = -1
                this.send = 1
                this.modal = 0
                var formData = new FormData()
                formData.append('crm', '9')
                formData.append('pipe', '17')
                formData.append('contact[name]', this.name)
                formData.append('contact[141]', this.phone)
                formData.append('contact[142]', this.email)
                formData.append('contact[143]', this.city)
                formData.append('contact[144]', this.user.uid)
                formData.append('lead[145]', this.text)
                formData.append('lead[146]', this.date + ' ' + this.time)
                formData.append('lead[147]', this.city)
                formData.append('lead[148]', this.user.uid)
                axios.post('https://urist1.v-avtoservice.com/api/import-lead',
                    formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                )
            }
        }
    }
}
</script>

<style scoped>
#modals > div {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    background: white;
}
</style>



// WEBPACK FOOTER //
// src/components/include/modals.vue